import React from 'react';
import { IconChevronLeft } from '@americanexpress/dls-icons';
import {
  useLoungeAirportLinkUrl,
  useLoungeAirportIata,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { formatText } from '@/helpers/utils';
import LFLink from '../LFLink';

type LoungeFinderBreadcrumbProps = {
  loungeId?: string;
};

const LoungeFinderBreadcrumb: React.FC<LoungeFinderBreadcrumbProps> = ({
  loungeId,
}) => {
  const link = useLoungeAirportLinkUrl(loungeId);
  const iata = useLoungeAirportIata(loungeId);
  const { header } = useCommonContent();

  if (!header || !iata) return null;

  return (
    <LFLink
      detail={`breadcrumb-${link}`}
      element="breadcrumb"
      to={link}
      className="tw-text-base tw-text-blue-bright-100 tw-no-underline before_tw-hidden after_tw-hidden hover_tw-underline"
    >
      <p>
        <IconChevronLeft
          color="white"
          className="tw-mb-px tw-ml-0dot5 tw-mr-1"
        />
        {`${formatText(header?.link, { iata })}`}
      </p>
    </LFLink>
  );
};

export default LoungeFinderBreadcrumb;
